type OidcServiceModule = typeof import('./ussOidcService');

import { env } from '../config/env';

let oidcServicePromise: Promise<OidcServiceModule> | null = null;
const isEnvLocalMode = env.localMode;

export function isLocalhostEnvironment(): boolean {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function shouldBypassOidc(): boolean {
  return isLocalhostEnvironment() || isEnvLocalMode;
}

export async function loadOidcService(): Promise<OidcServiceModule | null> {
  if (shouldBypassOidc()) {
    return null;
  }

  if (!oidcServicePromise) {
    oidcServicePromise = import('./ussOidcService');
  }

  return oidcServicePromise;
}
